import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteRecordRaw,
} from 'vue-router';
import { usePartnerStore } from './store/partner-store';
import { PartnerType } from './partner-types';

const partnerRoutes: Array<RouteRecordRaw> = [
  {
    path: 'clients',
    component: () =>
      import(
        '@/app/partner/components/partner-list/partner-list-index-component.vue'
      ),
    name: 'app.clients',
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ): void => {
      const partnerStore = usePartnerStore();
      partnerStore.setType(PartnerType.CLIENT);
      next();
    },
  },
  {
    path: 'subcontractors',
    component: () =>
      import(
        '@/app/partner/components/partner-list/partner-list-index-component.vue'
      ),
    name: 'app.subcontractors',
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ): void => {
      const partnerStore = usePartnerStore();
      partnerStore.setType(PartnerType.SUPPLIER);
      next();
    },
  },
  {
    path: '',
    component: () =>
      import(
        '@/app/partner/components/partner-show/partner-show-index-component.vue'
      ),
    children: [
      {
        path: 'partner/:partnerId/details',
        component: () =>
          import(
            '@/app/partner/components/partner-show/details/partner-details-component.vue'
          ),
        name: 'app.partner.details',
      },
      {
        path: 'partner/:partnerId/contacts',
        component: () =>
          import(
            '@/app/partner/components/partner-show/contacts/partner-contacts-component.vue'
          ),
        name: 'app.partner.contacts',
      },
      {
        path: 'partner/:partnerId/projects',
        component: () =>
          import(
            '@/app/partner/components/partner-show/projects/partner-projects-component.vue'
          ),
        name: 'app.partner.projects',
      },
    ],
  },
];

export default partnerRoutes;
